 
import React, { useState, useEffect } from "react";
import {
  Card,
  CardTitle,
  CardBody,
  Row,
  Col,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from "reactstrap";

import { URL } from "../../api";
import axiosInstance from "../../Request";




const BankingCredit = ({ cid, banking_data }) => {
  const [bankingModal, setBankingModal] = useState(false);
  const [bankingData, setBankingData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusText, setStatusText] = useState("Pending");
  const [dataFetched, setDataFetched] = useState(false);

  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
 
   const [zoom, setZoom] = useState(1);

  const zoomIn = () => setZoom((prev) => Math.min(prev + 0.1, 3));
  const zoomOut = () => setZoom((prev) => Math.max(prev - 0.1, 0.5));


  useEffect(() => {
    setStatusText(banking_data ? "Done" : "Pending");
  }, [banking_data]);

 
const fetchStatus = async () => {
  setLoading(true);
  try {
    const response = await axiosInstance.get(`${URL.BANKING_DATA}?customer_id=${cid}`);
    const data = response.data;
    setBankingData(data);
    setDataFetched(true);

       const anyAccountExists = Array.isArray(data) && data.some(d => d.accountNo !== null);
    setStatusText(anyAccountExists ? "Done" : "Pending");
  } catch (error) {
    console.error("Error fetching banking data:", error);
    setStatusText("Pending");
  }
  setLoading(false);
};

  const toggleBankingModal = async () => {
    const opening = !bankingModal;
    setBankingModal(opening);

    if (opening && !dataFetched) {
      await fetchStatus();
    }
  };

  const handleStatusClick = async () => {
    if (!dataFetched) {
      await fetchStatus();
    }
    setBankingModal(true);
  };

  const handleViewClick = async (item) => {
    try {
      const response = await axiosInstance.get(
        `${URL.BANKING_ACCOUNTS_PDF}?customer_id=${cid}&account_id=${item.accountId}`
      );

      if (response.data && response.data.url) {
        setPdfUrl(response.data.url);         
        setPdfModalOpen(true);               
      } else {
        console.error("No URL found in response.");
      }
    } catch (error) {
      console.error("Error fetching PDF URL:", error);
    }
  };

  const togglePdfModal = () => {
    setPdfModalOpen(!pdfModalOpen);
    if (pdfModalOpen) setPdfUrl(null);
  };

  return (
    <>
      <Col xs="6" sm="4" md="3">
        <Card className="card-stats mb-4">
          <CardBody>
            <Row>
              <div className="col">
                <CardTitle tag="h5" className="text-uppercase text-muted mb-0">
                  Banking
                </CardTitle>
                <span
                  className={`h2 font-weight-bold mb-0 ${
                    statusText === "Done" ? "text-success" : "text-danger"
                  }`}
                  style={{ cursor: "pointer" }}
                  onClick={handleStatusClick}
                >
                  {loading ? "Loading..." : statusText}
                </span>
              </div>
            </Row>
          </CardBody>
        </Card>
      </Col>

      {/* Banking Data Modal */}
      <Modal
        id="bankingModal"
        isOpen={bankingModal}
        toggle={toggleBankingModal}
        size="lg"
      >
        <ModalHeader toggle={toggleBankingModal}>Banking</ModalHeader>
        <ModalBody>
          {loading ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : bankingData.length === 1 && bankingData[0].accountId === null ? (
            <div className="text-center">
              <h5>{bankingData[0].status}</h5>
            </div>
          ) : (
            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th>Bank Name</th>
                  <th>From</th>
                  <th>To</th>
                  <th>Account Create Date</th>
                  <th>Bank Account Name</th>
                  <th>Status</th>
                  <th>Bank Account Number</th>
                  <th>Name Match Score</th>
                   <th>Vue</th>
            <th>Create Date</th>


                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {bankingData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.fipName || "N/A"}</td>
                    <td>{item.startDate || "N/A"}</td>
                    <td>{item.endDate || "N/A"}</td>
                    <td>
                      {item.accountCreateDate
                        ? new Date(item.accountCreateDate).toLocaleDateString()
                        : "N/A"}
                    </td>
                    <td>{item.name || "N/A"}</td>
                    <td>{item.status || "N/A"}</td>
                    <td>{item.accountNo || "N/A"}</td>
                    <td>
                      {item.nameMatchScore !== null
                        ? `${item.nameMatchScore}%`
                        : "N/A"}
                    </td>
                  <td>{item.vue || "N/A"}</td>
                <td>
                      {item.createDate
                        ? new Date(item.createDate).toLocaleDateString()
                        : "N/A"}
                    </td>

                    <td>
                      <Button
                        color="primary"
                        size="sm"
                        onClick={() => handleViewClick(item)}
                       >
                        View
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleBankingModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>


      {/* PDF Preview Modal */}
      {/* <Modal isOpen={pdfModalOpen} toggle={togglePdfModal} size="xl">
        <ModalHeader toggle={togglePdfModal}>PDF Preview</ModalHeader>
        <ModalBody style={{ height: "80vh"}}>
          {pdfUrl ? (
            <embed
              src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
              type="application/pdf"
              style={{ width: "100%", height: "100%", border: "none" }}
            />
          ) : (
            <div>Loading PDF...</div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={togglePdfModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal> */}
       <Modal isOpen={pdfModalOpen} toggle={togglePdfModal} size="xl">
      <ModalHeader toggle={togglePdfModal}>PDF Preview</ModalHeader>
      <ModalBody style={{ height: "80vh", overflow: "auto" }}>
        <div style={{ marginBottom: "10px", textAlign: "center" }}>
          <Button onClick={zoomOut} color="primary" size="sm" className="me-2">
            ➖ Zoom Out
          </Button>
          <Button onClick={zoomIn} color="primary" size="sm">
            ➕ Zoom In
          </Button>
        </div>
        {pdfUrl ? (
          <div
            style={{
              transform: `scale(${zoom})`,
              transformOrigin: "top center",
              transition: "transform 0.2s",
              width: "100%",
            }}
          >
            <embed
              src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
              type="application/pdf"
              style={{ width: "100%", height: "80vh", border: "none" }}
            />
          </div>
        ) : (
          <div>Loading PDF...</div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={togglePdfModal}>
          Close
        </Button>
      </ModalFooter>
    </Modal>


  

    </>
  );
};

export default BankingCredit;


     {/* PDF Preview Modal */}
{/* <Modal isOpen={pdfModalOpen} toggle={togglePdfModal} size="xl">
  <ModalHeader toggle={togglePdfModal}>PDF Preview</ModalHeader>

//   {/* Zoom controls */}
//   {/* <div style={{ padding: "0.5rem 1rem", display: "flex", gap: "1rem" }}>
//     <Button size="sm" onClick={() => setZoom((z) => Math.max(z - 0.1, 0.5))}>
//       ➖ Zoom Out
//     </Button>
//     <Button size="sm" onClick={() => setZoom(1)}>
//       🔁 Reset ({Math.round(zoom * 100)}%)
//     </Button>
//     <Button size="sm" onClick={() => setZoom((z) => Math.min(z + 0.1, 2))}>
//       ➕ Zoom In
//     </Button>
//   </div>

//   <ModalBody style={{ height: "80vh", overflow: "auto" }}>
//     {pdfUrl ? (
//       <div
//         style={{
//           transform: `scale(${zoom})`,
//           transformOrigin: "top left",
//           width: `${100 / zoom}%`,
//         }}
//       >
//         <embed
//           src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
//           type="application/pdf"
//           style={{ width: "100%", height: "80vh", border: "none" }}
//         />
//       </div>
//     ) : (
//       <div>Loading PDF...</div>
//     )}
//   </ModalBody>
//   <ModalFooter>
//     <Button color="secondary" onClick={togglePdfModal}>
//       Close
//     </Button>
//   </ModalFooter>
// </Modal> */}

// import React, { useState, useEffect } from "react";
// import {
//   Card, CardTitle, CardBody, Row, Col, Table,
//   Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner
// } from "reactstrap";

// import { URL } from "../../api";
// import axiosInstance from "../../Request";

// import { Document, Page, pdfjs } from "react-pdf";
// import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
// import 'react-pdf/dist/esm/Page/TextLayer.css';
// import workerSrc from "pdfjs-dist/build/pdf.worker.entry";
// pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

// const BankingCredit = ({ cid, banking_data }) => {
//   const [bankingModal, setBankingModal] = useState(false);
//   const [bankingData, setBankingData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [statusText, setStatusText] = useState("Pending");
//   const [dataFetched, setDataFetched] = useState(false);

//   const [pdfUrl, setPdfUrl] = useState(null);
//   const [pdfModalOpen, setPdfModalOpen] = useState(false);
//   const [zoom, setZoom] = useState(1);
//   const [numPages, setNumPages] = useState(null);

//   useEffect(() => {
//     setStatusText(banking_data ? "Done" : "Pending");
//   }, [banking_data]);

//   const fetchStatus = async () => {
//     setLoading(true);
//     try {
//       const response = await axiosInstance.get(`${URL.BANKING_DATA}?customer_id=${cid}`);
//       const data = response.data;
//       setBankingData(data);
//       setDataFetched(true);
//       const anyAccountExists = Array.isArray(data) && data.some(d => d.accountNo !== null);
//       setStatusText(anyAccountExists ? "Done" : "Pending");
//     } catch (error) {
//       console.error("Error fetching banking data:", error);
//       setStatusText("Pending");
//     }
//     setLoading(false);
//   };

//   const toggleBankingModal = async () => {
//     const opening = !bankingModal;
//     setBankingModal(opening);
//     if (opening && !dataFetched) await fetchStatus();
//   };

//   const handleStatusClick = async () => {
//     if (!dataFetched) await fetchStatus();
//     setBankingModal(true);
//   };

//   const handleViewClick = async (item) => {
//     try {
//       const response = await axiosInstance.get(
//         `${URL.BANKING_ACCOUNTS_PDF}?customer_id=${cid}&account_id=${item.accountId}`
//       );
//       if (response.data && response.data.url) {
//         setPdfUrl(response.data.url);
//         setPdfModalOpen(true);
//       } else {
//         console.error("No URL found in response.");
//       }
//     } catch (error) {
//       console.error("Error fetching PDF URL:", error);
//     }
//   };

//   const togglePdfModal = () => {
//     setPdfModalOpen(!pdfModalOpen);
//     if (pdfModalOpen) {
//       setPdfUrl(null);
//       setZoom(1);
//     }
//   };

//   return (
//     <>
//       {/* Banking Status Card */}
//       <Col xs="6" sm="4" md="3">
//         <Card className="card-stats mb-4">
//           <CardBody>
//             <Row>
//               <div className="col">
//                 <CardTitle tag="h5" className="text-uppercase text-muted mb-0">
//                   Banking
//                 </CardTitle>
//                 <span
//                   className={`h2 font-weight-bold mb-0 ${statusText === "Done" ? "text-success" : "text-danger"}`}
//                   style={{ cursor: "pointer" }}
//                   onClick={handleStatusClick}
//                 >
//                   {loading ? "Loading..." : statusText}
//                 </span>
//               </div>
//             </Row>
//           </CardBody>
//         </Card>
//       </Col>

//       {/* Banking Data Modal */}
//       <Modal isOpen={bankingModal} toggle={toggleBankingModal} size="lg">
//         <ModalHeader toggle={toggleBankingModal}>Banking</ModalHeader>
//         <ModalBody>
//           {loading ? (
//             <div className="text-center"><Spinner color="primary" /></div>
//           ) : bankingData.length === 1 && bankingData[0].accountId === null ? (
//             <div className="text-center"><h5>{bankingData[0].status}</h5></div>
//           ) : (
//             <Table className="align-items-center table-flush" responsive>
//               <thead className="thead-light">
//                 <tr>
//                   <th>Bank Name</th><th>From</th><th>To</th><th>Create Date</th>
//                   <th>Bank Account Name</th><th>Status</th><th>Account No</th>
//                   <th>Name Match Score</th><th>View</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {bankingData.map((item, index) => (
//                   <tr key={index}>
//                     <td>{item.fipName || "N/A"}</td>
//                     <td>{item.startDate || "N/A"}</td>
//                     <td>{item.endDate || "N/A"}</td>
//                     <td>{item.createDate ? new Date(item.createDate).toLocaleDateString() : "N/A"}</td>
//                     <td>{item.name || "N/A"}</td>
//                     <td>{item.status || "N/A"}</td>
//                     <td>{item.accountNo || "N/A"}</td>
//                     <td>{item.nameMatchScore !== null ? `${item.nameMatchScore}%` : "N/A"}</td>
//                     <td>
//                       <Button color="primary" size="sm" onClick={() => handleViewClick(item)}>View</Button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           )}
//         </ModalBody>
//         <ModalFooter>
//           <Button color="secondary" onClick={toggleBankingModal}>Close</Button>
//         </ModalFooter>
//       </Modal>

//       {/* PDF Viewer Modal */}
//       <Modal isOpen={pdfModalOpen} toggle={togglePdfModal} size="xl">
//         <ModalHeader toggle={togglePdfModal}>PDF Preview</ModalHeader>

//         {/* Zoom Controls */}
//         <div style={{ padding: "0.5rem 1rem", display: "flex", gap: "1rem" }}>
//           <Button size="sm" onClick={() => setZoom(z => Math.max(z - 0.2, 0.5))}>➖ Zoom Out</Button>
//           <Button size="sm" onClick={() => setZoom(1)}>🔁 Reset ({Math.round(zoom * 100)}%)</Button>
//           <Button size="sm" onClick={() => setZoom(z => Math.min(z + 0.2, 3))}>➕ Zoom In</Button>
//         </div>

//         <ModalBody style={{ height: "80vh", overflowY: "auto" }}>
//           {pdfUrl ? (
//             <Document
//               file={pdfUrl}
//               onLoadSuccess={({ numPages }) => setNumPages(numPages)}
//               loading={<div>Loading PDF...</div>}
//             >
//               {Array.from(new Array(numPages || 0), (_, index) => (
//                 <Page
//                   key={`page_${index + 1}`}
//                   pageNumber={index + 1}
//                   scale={zoom}
//                   renderTextLayer={true}
//                   renderAnnotationLayer={true}
//                 />
//               ))}
//             </Document>
//           ) : (
//             <div>Loading PDF...</div>
//           )}
//         </ModalBody>

//         <ModalFooter>
//           <Button color="secondary" onClick={togglePdfModal}>Close</Button>
//         </ModalFooter>
//       </Modal>
//     </>
//   );
// };

// export default BankingCredit;

